import { createAuth0Client } from '@auth0/auth0-spa-js'
import type { Auth0Client } from '@auth0/auth0-spa-js'

let auth0: Auth0Client | undefined

export async function getAuth0() {
  if (!auth0) {
    const url = new URL(window.location.href)
    const invitation = url.searchParams.get('invitation')
    const organization = url.searchParams.get('organization')
    const organizationName = url.searchParams.get('organization_name')
    auth0 = await createAuth0Client({
      domain: import.meta.env.VITE_AUTH0_DOMAIN,
      clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
      cacheLocation: 'localstorage',
      authorizationParams: {
        redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        invitation: invitation || undefined,
        organization: organization || undefined,
        organization_name: organizationName || undefined
      }
    })
  }
  return auth0
}

export function parseJwt<T = Record<string, unknown>>(jwt: string): T | null {
  const b64DecodeUnicode = (str: string) =>
    decodeURIComponent(Array.prototype.map.call(atob(str), (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''))
  if (!jwt) {
    return null
  }
  try {
    return JSON.parse(b64DecodeUnicode(jwt.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
  } catch (e) {
    console.warn('parseJwt: failed to decode token payload', e)
    return null
  }
}
